import React, { createContext, useContext, useEffect, useState } from 'react';
import { shopIdentityApi } from '../utils/api';
import { useAuth } from './AuthContext';

/**
 * The signed-in shop's identity (GET /api/shop-identity): name, fullName,
 * logoUrl, phone, address, isDefaultTenant. Screens read the shop's name from
 * here instead of hard-coding Twigs. Twigs gets its previous values from the
 * backend fallback, so it sees no change.
 *
 * `shop` is null until loaded (and outside a provider, e.g. public pages), so
 * consumers render a neutral placeholder rather than another shop's name.
 */
const ShopIdentityContext = createContext(null);

export const ShopIdentityProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [shop, setShop] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setShop(null);
      return undefined;
    }
    let cancelled = false;
    shopIdentityApi.get()
      .then((r) => { if (!cancelled && r?.success) setShop(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [isAuthenticated]);

  return <ShopIdentityContext.Provider value={shop}>{children}</ShopIdentityContext.Provider>;
};

export const useShopIdentity = () => useContext(ShopIdentityContext);
